import { useCallback, useEffect, useState } from "react";
import { apiError } from "@/lib/format";

// Tiny data-fetch helper: returns { data, loading, error, reload }.
export function useAsync(fn, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const run = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fn();
      setData(res?.data ?? res);
    } catch (e) {
      setError(apiError(e, "Failed to load."));
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    run();
  }, [run]);

  return { data, loading, error, reload: run, setData };
}
